import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Link } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  description: {
    paddingTop: '2vh',
    fontSize: '16px',
    color: '#4e4e4e',
    textAlign: 'center',
    marginRight: '7vw',
    marginLeft: '7vw'
  },
  title: {
    fontWeight: 700,
    textAlign: 'center',
    fontSize: 32,
    marginTop: '8vh',
    lineHeight: 'normal'
  },
  repository: {
    textAlign: 'center',
    fontSize: 20,
    marginTop: '8vh',
    color: '#b15858'
  },
  url: {
    textAlign: 'center',
    fontSize: 20,
    marginTop: '1vh'
  }
}));

const Header = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        container
        justify="center"
        style={{ marginTop: '-1%' }}
      >
        <Grid item>
          <Typography className={classes.title}>SimuLTI</Typography>
          <Typography className={classes.description} >SimuLTI is a Linear time-invariant systems (LTI systems) simulator. The software shows the behavior of various possible configurations within a second order system. The software was coded in Python and uses wxPython and wxGlade to build the graphical interface.</Typography>
          <Typography className={classes.repository}>Repository</Typography>
          <Typography className={classes.url}>
            <Link
              component="a"
              href="https://github.com/davibaltar/simulti"
              target="_blank"
            >
              https://github.com/davibaltar/simulti
              </Link>
          </Typography>
        </Grid>
      </Grid>
      <hr style={{ borderColor: '#E8E8E8', borderTop: 'none', borderLeft: 'none', borderRight: 'none', paddingTop: '3vh' }} />
    </div>
  );
};


export default Header;